<template>
  <main class="c-app-content">
    <div class="c-app-title">
      <div>
        <h1>Danh sách phản ánh của người dân</h1>
      </div>
      <ul class="c-app-breadcrumb breadcrumb">
        <li class="breadcrumb-item"><router-link to="/">Callio</router-link></li>
        <li class="breadcrumb-item active">Danh sách phản ánh của người dân</li>
      </ul>
    </div>
    <div class="tile">
      <div class="c-action">
        <div class="row">
          <div class="col-lg-3 c-action__left">
            <span class="c-action__count">
              {{ $t('listSummary', [firstItemOfPage, lastItemOfPage, itemCount, 'phản ánh']) }}
            </span>
          </div>
          <div class="col-lg-9 c-action__right">
            <div class="c-search-all">
              <div class="c-search-all__inner">
                <i class="c-search-all__icon icon16-search-gadient"></i>
                <b-form-input
                    class="form-control form-control-sm is-border-1"
                    v-model="filterFormModel.keyword"
                    :placeholder="$t('keyword')"
                    @keyup="search"
                ></b-form-input>
              </div>
            </div>
            <user-group-select :model="filterFormModel" attribute="group"
                               v-if="$store.state.user.permissions.find(p => ['issueListAll', 'issueListGroup'].includes(p))"
                               is-filter @change="search" :ids="groupIds" place-holder="Chọn nhóm"></user-group-select>
            <user-select :model="filterFormModel" attribute="user" :group-filter="filterFormModel.group"
                         v-if="$store.state.user.permissions.find(p => ['issueListAll', 'issueListGroup'].includes(p))"
                         :groups-filter="groupIds" @change="search" :isFilter="true"
                         place-holder="Chọn người dùng"></user-select>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-6 c-action__right">
            <dropdown-multiple :model="filterFormModel" attribute="types" @change="search" :options="[
                {id: 1, label: 'Tư vấn sức khỏe phòng Covid'},
                {id: 2, label: 'Hỗ trợ y tế khẩn cấp (F0, F1)'},
                {id: 3, label: 'Hỗ trợ nhu yếu phẩm (HT-YP)'},
                {id: 4, label: 'Hỗ trợ tài chính (HT-09)'},
                {id: 5, label: 'Hỗ trợ lang thang (HT-LĐ)'},
                {id: 0, label: 'Khác'},
            ]" placeholder="Lọc nheo nhu cầu hỗ trợ"></dropdown-multiple>
          </div>
          <div class="col-lg-6 c-action__right">
            <dropdown :model="filterFormModel" attribute="status" label="Trạng thái" :options="[
                {value: null, text: 'Tất cả'},
                {value: 1, text: 'Khẩn cấp chờ duyệt'},
                {value: 2, text: 'Khẩn cấp đã duyệt'},
                {value: 3, text: 'Khẩn cấp đã từ chối'},
                {value: 4, text: 'Đã xoá'},
            ]" :right-menu="true" type="bordered" icon="icon12-sort-descending-primary" @change="search"></dropdown>
            <input-date-time :model="filterFormModel" attribute="from" format="DD/MM/YY HH:mm" @change="search"
                             placeholder="Thời gian từ"></input-date-time>
            <input-date-time :model="filterFormModel" attribute="to" format="DD/MM/YY HH:mm" @change="search"
                             placeholder="Thời gian đến"></input-date-time>
            <button class="btn btn-sm btn-primary" @click="load"><i class="fa fa-refresh mr-0"></i></button>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-3 c-action__left"></div>
          <div class="col-lg-9 c-action__right">
            <export-issue :filter="filterFormModel" :totalCount="itemCount" :getType="getType"
                          v-if="$store.state.user.permissions.includes('issueExport')"/>
            <button class="btn btn-sm btn-success" @click="newIssue">
              <i class="icon12-add-white icon-left"></i>
              {{ $t('create') }}
            </button>
          </div>
        </div>
      </div>
      <div v-if="listLoading" class="text-center text-primary">
        <b-spinner></b-spinner>
      </div>
      <div v-if="!listLoading && !itemCount" class="text-center text-danger">
        {{ $t('emptyList') }}
      </div>
      <div v-if="!listLoading && itemCount" class="c-template-table table-responsive">
        <table class="table table-bordered table-more table-hover">
          <thead>
          <tr>
            <th>Ngày phản ánh</th>
            <th>Thông tin người liên hệ</th>
            <th>Địa chỉ</th>
            <th>Nhu cầu hỗ trợ</th>
            <th>Ghi nhận bởi</th>
            <th></th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="item in items" :key="item._id">
            <td>{{ item.time | moment('DD/MM/YY HH:mm') }}</td>
            <td>
              <p><span>Tên: </span><b>{{ item.name ? item.name : $t('unknown') }}</b></p>
              <p><span>SĐT: </span><b>{{ item.number ? item.number : $t('unknown') }}</b></p>
              <p><span>Giới tính: </span><b>{{
                  item.gender ? item.gender === 'unknown' ? 'Không rõ' : item.gender === 'male' ? 'Nam' : 'Nữ' : 'Không rõ'
                }}</b></p>
              <p><span>Năm sinh: </span><b>{{ item.dob ? item.dob : $t('unknown') }}</b></p>
              <p><span>Số lượng người đang gặp khó khăn: </span><b>{{
                  item.peopleCount ? item.peopleCount : $t('unknown')
                }}</b></p>
              <p><span>Khi đển cứu trợ, liên hệ: </span><b>{{
                  item.needer_name ? item.needer_name : item.name ? item.name : $t('unknown')
                }}</b></p>
              <p v-if="item.emergency && !item.emergencyApproveTime" class="mb-1">
                <span class="badge badge-danger">Khẩn cấp cần duyệt</span>
              </p>
              <p v-if="item.emergencyApproved">
                <span class="badge badge-warning">Khẩn cấp đã duyệt</span>
              </p>
              <p v-if="!item.emergencyApproved && item.emergencyApproveTime">
                <span class="badge badge-secondary">Khẩn cấp bị từ chối</span>
              </p>
              <p v-if="item.emergency && !item.emergencyApproveTime && $store.state.user.permissions.includes('issueEmergencyApprove')">
                <button class="btn btn-sm btn-outline-gray mr-1 mb-1" @click="approveEmergency(item._id, true)"
                        :disabled="approveEmergencyLoading">
                  <b-spinner v-if="approveEmergencyLoading" small></b-spinner>
                  <i v-else class="fa fa-check"></i>
                  Duyệt
                </button>
                <button class="btn btn-sm btn-outline-gray mr-1 mb-1" @click="approveEmergency(item._id, false)"
                        :disabled="approveEmergencyLoading">
                  <b-spinner v-if="approveEmergencyLoading" small></b-spinner>
                  <i v-else class="fa fa-ban"></i>
                  Từ chối
                </button>
              </p>
              <p v-if="item.deleteTime"><span class="badge badge-danger">Đã xoá</span></p>
            </td>
            <td>
              <p>
                <span>Địa chỉ cần cứu trợ: </span><b>{{ item.supportAddress ? item.supportAddress : $t('unknown') }}</b>
              </p>
              <div v-html="getProvinceDistrictWard(item.provinceCode, item.districtCode, item.wardCode)"></div>
              <p>
                <span>Nằm trong vùng phong toả: </span>
                <span v-if="!item.blockadeArea" class="badge badge-secondary">Không rõ</span>
                <span v-else-if="item.blockadeArea === 1" class="badge badge-warning">Có</span>
                <span v-else class="badge badge-success">Không</span>
              </p>
            </td>
            <td>
              <p><b>{{ getType(item.type) }}</b></p>
            </td>
            <td>
              <div>{{ item.user.name }} - {{ item.user.ext }} ({{ item.user.email }})</div>
              <div v-if="item.call">
                <p>
                  <span class="small">{{ $t('duration') }}:&nbsp;</span>
                  <b class="text-success">{{ item.call.duration | callDuration }}</b>
                  &nbsp;|&nbsp;<span class="small">{{ $t('billDuration') }}:&nbsp;</span>
                  <b class="text-danger"
                     v-if="item.call.recordingDuration && (item.call.recordingDuration < item.call.billDuration)">{{
                      item.call.recordingDuration | callDuration
                    }}</b>
                  <b class="text-danger" v-else>{{ item.call.billDuration | callDuration }}</b>
                </p>
                <recording-player v-if="item.call.recording && item.call.recordingDownloaded" :id="item.call._id"
                                  :duration="item.call.recordingDuration && item.call.recordingDuration < item.call.billDuration ? item.call.recordingDuration : item.call.billDuration"/>
                <audio-quality-bar v-if="item.call.audioQuality" :vpMin="0" :vpNow="item.call.audioQuality"
                                   :vpMax="100"></audio-quality-bar>
                <p class="small">
                <span class="small"
                      v-if="item.call.direction === 'inbound' && ((item.call.hangupCause === 'NORMAL_CLEARING' && item.call.toExt && item.call.toExt.length < 5) || item.call.hangupCause !== 'NORMAL_CLEARING' || !item.call.billDuration)">
                  <b class="text-danger">{{ $t('missCall') }}</b> |
                </span>
                  <span v-if="item.call.billDuration >= 1">{{ $t('connectedSuccessfully') }} |</span>
                  &nbsp;<span>{{ item.call.hangupCause }}</span>
                </p>
              </div>
            </td>
            <td>
              <button class="btn btn-sm btn-outline-gray mr-1 mb-1" @click="update(item._id)" :disabled="updateLoading"
                      v-if="issueUpdatePermission(item)">
                <b-spinner v-if="updateLoading" small></b-spinner>
                <i v-else class="fa fa-edit"></i>
                {{ $t('edit') }}
              </button>
              <button class="btn btn-sm btn-outline-gray mr-1 mb-1" @click="del(item._id)" :disabled="delLoading"
                      v-if="$store.state.user.role === 'owner' && !item.deleteTime">
                <b-spinner v-if="delLoading" small></b-spinner>
                <i v-else class="icon12-delete-primary"></i>
                {{ $t('delete') }}
              </button>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <div class="c-paging" v-if="itemCount > filterFormModel.pageSize">
        <b-pagination
            size="sm"
            class="pagination pagination-sm justify-content-center"
            v-model="filterFormModel.page"
            :total-rows="itemCount"
            :per-page="filterFormModel.pageSize"
            @input="load"
        >
        </b-pagination>
      </div>
    </div>
    <b-modal size="xxl" v-model="showForm" :title="formTitle + ' phản ánh của người dân'"
             @ok="save" no-close-on-backdrop no-enforce-focus>
      <div class="row">
        <div class="col-md-4">
          <form-input
              label="Họ và tên người liên hệ"
              :model="formModel"
              attribute="name"
              :errors="formErrors"
              placeholder="Họ tên người liên hệ"
          ></form-input>

          <form-input
              label="Số điện thoại người liên hệ"
              :model="formModel"
              attribute="number"
              :errors="formErrors"
              placeholder="Số điện thoại người liên hệ"></form-input>

          <form-radio-group :model="formModel" attribute="needer" errors="formErrors"
                            label="Cần hỗ trợ cho bản thân hay cho người khác" :options="[
            {value: true, text: 'Cho bản thân'},
            {value: false, text: 'Cho người khác'},
          ]"></form-radio-group>

          <form-input
              label="Họ và tên người cần hỗ trợ"
              :model="formModel" :disabled="formModel.needer"
              attribute="needer_name"
              :errors="formErrors"
              placeholder="Họ tên người cần hỗ trợ"
          ></form-input>

          <form-input
              label="Số điện thoại người cần hỗ trợ"
              :model="formModel"
              attribute="needer_number"
              :errors="formErrors" :disabled="formModel.needer"
              placeholder="Số điện thoại người cần hỗ trợ"></form-input>
          <form-radio-group :model="formModel" attribute="gender" errors="formErrors" label="Giới tính người cần hỗ trợ"
                            :options="genderOptions"></form-radio-group>
          <form-input
              label="Năm sinh người cần hỗ trợ"
              :model="formModel"
              attribute="dob"
              :errors="formErrors"
              placeholder="Năm sinh người cần hỗ trợ"
          ></form-input>

          <form-input
              label="Nghề nghiệp người cần hỗ trợ"
              :model="formModel"
              attribute="job"
              :errors="formErrors"
              placeholder="Nghề nghiệp người cần hỗ trợ"
          ></form-input>
        </div>
        <div class="col-md-8">
          <form-group-address
              :model="formModel"
              province-attribute="provinceCode"
              :province-disabled="false"
              district-attribute="districtCode"
              ward-attribute="wardCode"
              :errors="formErrors"
          ></form-group-address>

          <form-input
              label="Địa chỉ cần cứu trợ"
              :model="formModel"
              attribute="supportAddress"
              :errors="formErrors"
              placeholder="Địa chỉ cần cứu trợ"
          ></form-input>
          <div class="row">
            <div class="col-md-6">
              <form-input
                  label="Số người đang gặp khó khăn"
                  :model="formModel"
                  attribute="peopleCount"
                  :errors="formErrors"
                  placeholder="Số người cần cứu trợ"
                  type="number"
              ></form-input>
              <form-textarea
                  label="Mô tả chi tiết nhu cầu hỗ trợ"
                  :model="formModel"
                  attribute="note"
                  row="7"
                  placeholder="Mô tả chi tiết nhu cầu hỗ trợ"
                  :errors="formErrors"
              ></form-textarea>

              <form-select
                  label="Có nằm trong vùng phong tỏa hay không"
                  :model="formModel"
                  attribute="blockadeArea"
                  :errors="formErrors"
                  :options="[
            {value: null, text: 'Không rõ'},
            {value: 1, text: 'Có'},
            {value: 2, text: 'Không'},
          ]"
              ></form-select>
            </div>
            <div class="col-md-6">
              <form-radio-group :stacked="true" :model="formModel" attribute="type" :errors="formErrors"
                                label="Nhu cầu cần hỗ trợ"
                                :options="typeOptions"></form-radio-group>
              <form-checkbox-group v-if="formModel.type === 3" stacked label="Nhu cầu nhu yếu phẩm"
                                   :model="formModel" attribute="htyp" :errors="formErrors"
                                   :options="[
                                    {value: 'Sữa', text: 'Sữa'},
                                    {value: 'Gạo', text: 'Gạo'},
                                    {value: 'Mỳ', text: 'Trứng'},
                                    {value: 'Rau', text: 'Rau'},
                                    {value: 'Mì tôm', text: 'Mì tôm'},
                                    {value: 'Thịt cá', text: 'Thịt cá'},
                                  ]"></form-checkbox-group>
              <form-radio-group :model="formModel" attribute="emergency" errors="formErrors" class="text-danger"
                                label="Mức độ cần trợ giúp"
                                :options="[{value: false, text: 'Không khẩn cấp'},
            {value: true, text: 'Khẩn cấp'}]"></form-radio-group>

            </div>
          </div>
        </div>
      </div>

      <template v-slot:modal-footer>
        <b-button variant="secondary" class="float-right" @click="showForm = false">Đóng</b-button>
        <b-button :disabled="saveLoading" variant="primary" class="float-right" @click="save">
          <b-spinner v-if="saveLoading" small></b-spinner>
          {{ $t('save') }}
        </b-button>
      </template>
    </b-modal>
  </main>
</template>

<script>
import list from '@/mixins/List';
import crud from '@/mixins/CRUD';
import _ from 'lodash';
import Dropdown from '@/components/Dropdown';
import UserSelect from '@/components/UserSelect';
import UserGroupSelect from '@/components/UserGroupSelect';
import FormGroupAddress from '@/components/address/FormGroupAddress.vue';
import provinceData from './vn-adm.json';
import ExportIssue from "@/views/1022/IssueExport";
import AudioQualityBar from "@/views/history/AudioQualityBar";
import RecordingPlayer from "@/components/RecordingPlayer";
import moment from 'moment';
import DropdownMultiple from "@/components/DropdownMultiple";

export default {
  components: {
    DropdownMultiple,
    RecordingPlayer,
    UserSelect,
    Dropdown,
    UserGroupSelect,
    FormGroupAddress,
    ExportIssue,
    AudioQualityBar
  },
  mixins: [list, crud],
  data: function () {
    return {
      provinceData,
      service: '/issue',
      autoLoad: true,
      reloadBus: 'reloadIssueList',
      defaultFilterFormModel: {
        keyword: null,
        group: null,
        user: null,
        type: null,
        from: moment(Date.now()).startOf('month').format('x'),
        to: moment(Date.now()).endOf('day').format('x'),
        emergencyStatus: null
      },
      defaultFormModel: {

      },
      typeOptions: [
        {value: 1, text: 'Tư vấn sức khỏe phòng Covid'},
        {value: 2, text: 'Hỗ trợ y tế khẩn cấp (F0, F1)'},
        {value: 3, text: 'Hỗ trợ nhu yếu phẩm (HT-YP)'},
        {value: 4, text: 'Hỗ trợ tài chính (HT-09)'},
        {value: 5, text: 'Hỗ trợ lang thang (HT-LĐ)'},
        {value: 0, text: 'Khác'},
      ],
      genderOptions: [
        {value: 'male', text: 'Nam'},
        {value: 'female', text: 'Nữ'},
        {value: 'unknown', text: 'Không rõ'},
      ],
      approveEmergencyLoading: false
    };
  },
  methods: {
    search: _.debounce(function () {
      this.filterFormModel.page = 1;
      this.load();
    }, 200),
    makeCall(number) {
      this.$bus.$emit('makeCall', number);
    },
    getProvinceDistrictWard(provinceCode, districtCode, wardCode) {
      let result = {
        province: 'Không rõ',
        district: 'Không rõ',
        ward: 'Không rõ'
      }
      if (provinceCode) {
        let province = this.provinceData.find(p => parseInt(p.value) === provinceCode);
        if (province) {
          result.province = province.text;
          let district = province.districts.find(d => parseInt(d.value) === districtCode);
          if (district) {
            result.district = district.text;
            let ward = district.wards.find(w => parseInt(w.value) === wardCode);
            if (ward) {
              result.ward = ward.text;
            }
          }
        }
      }
      return `
                    <p><span>Tỉnh/ TP: </span><b>${result.province}</b></p>
                    <p><span>Quận/ Huyện: </span><b>${result.district}</b></p>
                    <p><span>Xã/ Phường: </span><b>${result.ward}</b></p>
              `
    },
    getType(type) {
      switch (type) {
        case 0:
          return 'Khác';
        case 1:
          return 'Tư vấn sức khỏe phòng Covid'
        case 2:
          return 'Hỗ trợ y tế khẩn cấp (F0, F1)'
        case 3:
          return 'Hỗ trợ nhu yếu phẩm (HT-YP)'
        case 4:
          return 'Hỗ trợ tài chính (HT-09)'
        case 5:
          return 'Hỗ trợ lang thang (HT-LĐ)'
      }
      return 'không rõ'
    },
    newIssue() {
      this.$bus.$emit('newIssueManually');
    },
    approveEmergency(id, action) {
      this.$swal({
        icon: 'warning',
        text: action ? 'Bạn có chắc muốn duyệt khẩn cấp?' : 'Bạn có chắc muốn từ chối khẩn cấp?',
        showCancelButton: true
      }).then(result => {
        if (result.value) {
          this.approveEmergencyLoading = true;
          this.$service.post('/issue/approve-emergency/' + id, {approve: action}).then(response => {
            if (response && response.data) {
              this.$swal({
                icon: 'success',
                text: 'Lưu thông tin thành công',
                toast: true,
                timer: 5000,
                position: 'top-end'
              })
              this.load()
            } else {
              this.$swal({
                icon: 'error',
                text: 'Lưu thông tin thất bại'
              })
            }
          }).catch(error => {
            if (error.response.data.message) {
              this.$swal({
                text: error.response.data.message,
                icon: 'error'
              });
            }
          }).finally(() => {
            this.approveEmergencyLoading = false;
          });
        }
      })
    },
    issueUpdatePermission(item) {
      if (this.$store.state.user.permissions.includes('issueUpdateAll')) {
        return true
      } else if (item.user) {
        if (this.$store.state.user.permissions.includes('issueUpdateGroup')) {
          if (!item.user.group && this.$store.state.user.roleGroups.includes('default')) {
            return true
          }
          if (item.user.group && this.$store.state.user.roleGroups.includes(item.user.group)){
            return true
          }
        } else if (this.$store.state.user._id === item.user._id) {
          return true
        }
      }
      return false
    },
  },
  computed: {
    groupIds() {
      if (
          this.$store.state.user.permissions.includes('issueListGroup') &&
          !this.$store.state.user.permissions.includes('issueListAll')
      ) {
        return this.$store.state.user.roleGroups;
      }
      return null;
    },
  },
};
</script>
